<div class="usan-form-item proof-of-payment-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasProofOfPaymentFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="usan-form-item proof-of-payment-item proof-of-payment-text">
        Proof of Payment
        <ul>
          <li>PDF copy of the wire transfer confirmation, showing banking information</li>
        </ul>
      </span>
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-proof-of-payment form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
       <span class="form-btn-icon material-icons">upload</span>
       Upload Proof of payment
    </button>
  </div>
  <ng-container *ngIf="hasProofOfPaymentFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>